// extracted by mini-css-extract-plugin
export default {"container":"UploadWorkspaceFileUploadStatusOverlay_container__mh9Dx","percentageText":"UploadWorkspaceFileUploadStatusOverlay_percentageText__eQJsn"};